









































































import {
  InstrumentDetail,
  InstrumentPerformanceData
} from "@/shared/types";
import { Component, Prop, Vue } from "@/shared/vuepack";
import MorningstarAnalystTable from "@/shared/components/investments/drivewealth/MorningstarAnalystTable.vue";
import { roundToTwoDecimals } from "@/shared/mathHelper";
import { formatCurrency } from "@/shared/currency";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useInstrumentPerformanceDataStore } from "@/shared/store/instrumentPerformanceData";

@Component({
  components: {
    MorningstarAnalystTable
  }
})
export default class EquityPerformanceSection extends Vue {
  @Prop({ required: false }) username: string;
  @Prop({ required: false }) partnerId: number;
  @Prop() symbol: string;
  @Prop() accountId: number;

  instrumentPerformanceDataStore = useInstrumentPerformanceDataStore();
  drivewealthStore = useDrivewealthStore();

  formatCurrency = formatCurrency;
  roundToTwoDecimals = roundToTwoDecimals;

  get instrumentDetail (): InstrumentDetail {
    return this.drivewealthStore.instrumentDetailBySymbol(this.symbol);
  }

  get previousDayClosePrice (): number {
    return this.instrumentPerformanceDataStore.previousDayClosePrice(this.symbol);
  }

  get instrumentPerformanceData (): InstrumentPerformanceData {
    return this.instrumentPerformanceDataStore.instrumentPerformanceData(this.symbol);
  }
}
